import { useMutation, useQuery } from "react-query";
import { blockUser, getConnectionList, getMessages, readMessage, sendMessage, unblockUser, unReadMessage } from "../services";
import { getUser } from "../utils/jwt";

export const useGetMessages = (accountId, page = 1, perPage = 30, options = {}) => {
  return useQuery(
    ["messages", accountId, page, perPage],
    () => getMessages(accountId, page, perPage),
    {
      retry: 0,
      ...options,
    }
  );
};

export const useSendMessage = () => {
  // const queryClient = useQueryClient();

  return useMutation(sendMessage, {
    onSuccess: () => {
      // Handle success, e.g., invalidate queries or update state
    },
    onError: () => {
      // Handle error, e.g., show a notification
    },
  });
};

export const useGetConnectionList = () => {
  const { accountId } = getUser() || {};
  return useQuery(
    ["connectionList", accountId],
    () => getConnectionList(accountId),
    {
      enabled: !!accountId,
    }
  );
};


export const useBlockUser = () => {
  return useMutation(blockUser);
};

export const useUnblockUser = () => {
  return useMutation(unblockUser);
};

export const useReadMessage = () => {
  return useMutation(readMessage, {
    mutationKey: ['readMessage']
  });
};

export const useUnReadMessage = () => {
  return useMutation(unReadMessage, {
    mutationKey: ['unReadMessage']
  });
};